import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class AccountService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/v2/accounts', query);
  }

  create(body: any) {
    return this.post('/v2/admin/settings/account', body);
  }

  find(id) {
    return this.get('/v2/account/' + id);
  }

  update(id, body) {
    return this.put('/v2/account/' + id, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Account.service.ts